import React, { useRef, useEffect, useState } from 'react';
import './BlogPost.scss';
import { BiComment, BiShow } from 'react-icons/bi';
import { GetBlogCategories, GetFeaturedPostList, GetPostList } from 'services/blogs/blogs';
import { errorResponse, failResponse, normalEncryptData } from "config/config";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdThumbUp, MdThumbDown, MdVisibility, MdComment } from "react-icons/md";

const BlocksPage = () => {
  const [posts, setPosts] = useState([]);
  const [featuredPosts, setFeaturedPosts] = useState([]);
  const [blogcategories, setblogcategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [total, setTotal] = useState(0);
  const [allPosts, setAllPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const postsPerPage = 5;

  const navigate = useNavigate();

  const scrollRef = useRef(null);
  const [isAtTop, setIsAtTop] = useState(true);
  const [isAtBottom, setIsAtBottom] = useState(true); // default to true before Load More
  const [loadMoreClicked, setLoadMoreClicked] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;

      setIsAtTop(scrollTop <= 5);
      setIsAtBottom(scrollTop + clientHeight >= scrollHeight - 5);
    };

    const container = scrollRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll);
      // Initial check (in case of programmatic scroll)
      handleScroll();
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, [loadMoreClicked]);

  useEffect(() => {
    if (loadMoreClicked) {
      // Delay to allow DOM update
      const timeout = setTimeout(() => {
        scrollRef.current?.scrollBy({ top: 300, behavior: 'smooth' });
        setLoadMoreClicked(true);
      }, 100); // 100ms is enough, can increase if needed

      return () => clearTimeout(timeout);
    }
  }, [allPosts]); // Trigger only when posts update


  const scrollUp = () => {
    scrollRef.current?.scrollBy({ top: -300, behavior: 'smooth' });
  };

  const scrollDown = () => {
    scrollRef.current?.scrollBy({ top: 300, behavior: 'smooth' });
  };






  const banners = [
    {
      image: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?auto=format&fit=crop&w=600&q=80',
    },
    {
      image: 'https://images.unsplash.com/photo-1524995997946-a1c2e315a42f?auto=format&fit=crop&w=600&q=80',
    },
  ];

  useEffect(() => {
    const getPostListData = async () => {
      try {
        const res = await GetPostList();
        if (res.code === 200) {
          setPosts(res.data.Posts.rows || []);
          setTotal(res.data.Posts.count || []);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      } finally {
        setLoading(false);
      }
    };
    getPostListData();
  }, []);

  useEffect(() => {
    const getFeaturedPostListData = async () => {
      try {
        const res = await GetFeaturedPostList();
        if (res.code === 200) {
          setFeaturedPosts(res.data.Featuredposts.rows || []);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      } finally {
        setLoading(false);
      }
    };
    getFeaturedPostListData();
  }, []);

  useEffect(() => {
    const getBlogCategories = async () => {
      try {
        const res = await GetBlogCategories();
        if (res.code === 200) {
          setblogcategories(res.data.blogCategories || []);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      } finally {
        setLoading(false);
      }
    };
    getBlogCategories();
  }, []);

  useEffect(() => {
    const fetchInitialPosts = async () => {
      try {
        const res = await GetPostList({ page: 1, limit: postsPerPage });
        if (res.code === 200) {
          const initialPosts = res.data.Posts.rows || [];
          setAllPosts(initialPosts);
          setTotal(res.data.Posts.count || 0);
          setHasMore(res.data.Posts.count > 5);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      } finally {
        setLoading(false);
      }
    };
    fetchInitialPosts();
  }, []);

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % (posts.length || 1));
    }, 4000);
    return () => clearInterval(slideInterval);
  }, [posts.length]);

  if (loading) return <div>Loading...</div>;
  if (posts.length === 0) return <div>No posts found.</div>;




  const loadMorePosts = async () => {
    try {
      const nextPage = currentPage + 1;
      const res = await GetPostList({ page: nextPage, limit: postsPerPage }); // Adjust API if needed
      if (res.code === 200) {
        const newPosts = res.data.Posts.rows || [];
        setAllPosts(prev => [...prev, ...newPosts]);
        setCurrentPage(nextPage);
        setHasMore(newPosts.length === postsPerPage);
        setLoadMoreClicked(true);
      } else {
        failResponse(res);
      }
    } catch (err) {
      errorResponse(err);
    }
  };


  return (
    <div className="blocks-page">
      {/* Banner */}
      <div className="banner">
        <img src={banners[0].image} alt="Books" className="banner-img banner-img-1" />
        <img src={banners[1].image} alt="Books" className="banner-img banner-img-2" />
        <h1 className="banner-title">Power Your Prep with Insightful Blog Articles</h1>
        <p className="banner-subtitle">Discover Winning Strategies in Our Blog Series</p>
      </div>

      {/* Main Content */}
      <div className="content">
        <div className="content-left">
          <div className='sectionfirst'>
            <div className='sectionfirst-card'>
              <h4 className='sectionfirst-card-title'>Want to be aware of everything?</h4>
            </div>
          </div><br />

          {/* Featured Post */}
          <div className="post">
            <img src={posts[0]?.poster} alt={posts[0]?.title} className="post-image" />
            <div className="post-details">
              <h1 className="post-title">
                {posts[0].slug ? (
                  // <a href={`/blog/${posts[0]?.slug}`}>{posts[0]?.title}</a>
                  <Link
                    to={`/blog/${posts[0]?.slug}`}
                    state={{ id: posts[0]?.id, title: posts[0]?.title }}
                  >
                    {posts[0]?.title}
                  </Link>
                ) : (
                  <Link
                    to={`/blog-post-detail/${posts[0]?.id}`}
                    state={{ id: posts[0]?.id, title: posts[0]?.title }}
                  >
                    {`/blog-post-detail/${posts[0]?.id}`}
                  </Link>
                )}

              </h1>

              <div className='post-detail-content'>
                <small className="post-date">By {posts[0]?.addedby || "Shubhra Ranjan"}</small>
                <small className="post-date">
                  {posts[0]?.publisheddate ? `At ${new Date(posts[0]?.publisheddate).toLocaleDateString('en-GB', {
                    day: '2-digit',
                    month: 'long',
                    year: 'numeric',
                  })}` : 'Not Published'}
                </small>
                <small className="post-date">{posts[0]?.categoryname || "General"}</small>
              </div>
              <p className="post-content">{posts[0]?.shortdescription}</p>
              <div className="post-stats">
                <div className="post-stats">
                  <div className="reaction-row-view">
                    <MdVisibility size={16} /> <span>{posts[0]?.postviews || 0}</span>
                  </div>
                  <div className="reaction-row-comment">
                    <MdComment size={16} /> <span>{posts[0]?.postcommentcount || 0}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Other Posts */}
          <div className="other-posts-wrapper">

            <div className="other-posts" ref={scrollRef}>
              {allPosts
                .slice(1) // since first post is separately shown
                .map(({ id, title, slug, poster, shortdescription, publisheddate, categoryname, addedby, postcommentcount, postviews }, idx) => (
                  <div key={idx} className="small-post">
                    <img src={poster} alt={title} className="small-post-image" />
                    <div className="post-details">
                      {/* <h1 className="post-title">
                        {slug ? (
                          <a href={`/blog/${slug}`}>{title}</a>
                        ) : (
                          <a href={`/blog-post-detail/${id}`}>{title}</a>
                        )}

                      </h4> */}
                      <h1 className="post-title">
                        {slug ? (
                          // <a href={`/blog/${posts[0]?.slug}`}>{posts[0]?.title}</a>
                          <Link
                            to={`/blog/${slug}`}
                            state={{ id: id, title: title }}
                          >
                            {title}
                          </Link>
                        ) : (
                          <Link
                            to={`/blog-post-detail/${id}`}
                            state={{ id: id, title: title }}
                          >
                            {`/blog-post-detail/${id}`}
                          </Link>
                        )}

                      </h1>
                      <div className='post-detail-content'>
                        <small className="post-date">By {addedby || "Shubhra Ranjan"}</small>
                        <small className="post-date">
                          {publisheddate ? `At ${new Date(publisheddate).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          })}` : 'Not Published'}
                        </small>

                        <small className="post-date">
                          {categoryname || "General"}</small>
                      </div>
                      <p className="post-content">{shortdescription}</p>
                      <div className="post-stats">
                        <div className="reaction-row-view">
                          <MdVisibility size={16} /> <span>{postviews || 0}</span>
                        </div>
                        <div className="reaction-row-comment">
                          <MdComment size={16} /> <span>{postcommentcount || 0}</span>
                        </div>                    </div>
                    </div>
                  </div>
                ))}


            </div>
            {loadMoreClicked && (
              <>
                {!isAtTop && (
                  <button className="scroll-arrow up" onClick={scrollUp}>↑</button>
                )}
                {!isAtBottom && (
                  <button className="scroll-arrow down" onClick={scrollDown}>↓</button>
                )}
              </>
            )}


          </div>


          {hasMore && (
            <div className="pagination-btn-load">
              <button
                onClick={async () => {
                  await loadMorePosts();
                  setLoadMoreClicked(true);
                }}
                className="pagination-btn-load-more"
              >
                Load More
              </button>
            </div>
          )}





        </div>




        {/* Right Panel */}
        <div className="content-right">
          <div className='featuredposts'>
            <h4 className="featuredposts-heading">Featured Posts</h4>
            <hr />
            {featuredPosts.slice(0, 4).map(({ id, title, slug, shortdescription, poster }) => (
              <React.Fragment key={id}>
                {slug ? (
                  <Link
                    to={`/blog/${slug}`}
                    state={{ id: id, title: title }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div
                      className="featuredpost"
                      style={{ display: "flex", gap: "12px", cursor: "pointer" }}
                    >
                      <img
                        src={poster}
                        alt={title}
                        className="banner-img banner-img-2"
                        style={{ width: "160px", borderRadius: "4px", height: "100px" }}
                      />
                      <div className="featuredpost-text">
                        <p className="featuredpost-text-heading">{title}</p>
                        <p className="featuredpost-text-content">{shortdescription}</p>
                      </div>
                    </div>
                  </Link>
                ) : (
                  <Link
                    to={`/blog-post-detail/${id}`}
                    state={{ id: id, title: title }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <div
                      className="featuredpost"
                      style={{ display: "flex", gap: "12px", cursor: "pointer" }}
                    >
                      <img
                        src={poster}
                        alt={title}
                        className="banner-img banner-img-2"
                        style={{ width: "160px", borderRadius: "4px", height: "100px" }}
                      />
                      <div className="featuredpost-text">
                        <p className="featuredpost-text-heading">{title}</p>
                        <p className="featuredpost-text-content">{shortdescription}</p>
                      </div>
                    </div>
                  </Link>
                )}
              </React.Fragment>
            ))}
          </div>


          <br />
          <div className='featuredcategories'>
            <h4 className="featuredcategories-heading">Categories</h4>
            <hr />
            <ul className="featuredcategory-list">
              {blogcategories.map((category) => (
                <li key={category.categoryid} className="featuredcategory-item">
                  <Link
                    to={`/blog-posts/${category.categoryid}/${category.title}`}
                    style={{ textDecoration: 'none', color: 'inherit', display: 'flex', justifyContent: 'space-between', width: '100%' }}
                  >
                    <span className="category-title">{category.title}</span>
                    <span className="subcategory-count">({category.postcounts || 0})</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>



          <div className="latest-posts">
            <h4 className="latest-posts-heading">Latest Posts</h4>
            <hr />

            {posts[currentSlide].slug ? (
              <div className="latest-post-slide" onClick={() =>
                navigate(`/blog/${posts[currentSlide].slug}`, {
                  state: {
                    id: posts[currentSlide].id,
                    title: posts[currentSlide].title
                  }
                })
              }>
                <img
                  src={posts[currentSlide]?.poster}
                  alt={posts[currentSlide]?.title}
                  className="latest-post-image"
                />
                <div className="latest-post-details">
                  <h5 className="latest-post-title">{posts[currentSlide]?.title}</h5>
                  <p className="latest-post-content">{posts[currentSlide]?.shortdescription}</p>
                </div>
              </div>
            ) : (
              <div className="latest-post-slide" onClick={() => navigate(`/blog-post-detail/${posts[currentSlide].id}`)}>
                <img
                  src={posts[currentSlide]?.poster}
                  alt={posts[currentSlide]?.title}
                  className="latest-post-image"
                />
                <div className="latest-post-details">
                  <h5 className="latest-post-title">{posts[currentSlide]?.title}</h5>
                  <p className="latest-post-content">{posts[currentSlide]?.shortdescription}</p>
                </div>
              </div>
            )}


          </div>
          <div className="join-community">
            <h4 className="sidebar-heading">Join the Community</h4>
            <hr />
            <h5>Shubhra Ranjan IAS Study</h5>
            <a href="https://t.me/sriasofficial" target="_blank" className="telegram-btn" rel="noopener noreferrer">
              <div className="icon-circle">
                <img src="https://upload.wikimedia.org/wikipedia/commons/8/82/Telegram_logo.svg" alt="Telegram" />
              </div>
              Join our Telegram Channel
            </a>
          </div>


        </div>
      </div>
    </div >
  );
};

export default BlocksPage;

